export const defaultStoreValues = {
  languageCode: 'RU',
  title: '',
  content: '',
  seoTitle: '',
  seoKeywords: '',
  seoDescription: '',
}
